import { ROLES } from '@/constants/roles';

/**
 * Sidebar groups, in order. The design splits the rail into « Pilotage »
 * (where you look) and « Gestion » (what you administer).
 */
export const MENU_GROUPS = [
  { key: 'pilotage', label: 'Pilotage' },
  { key: 'gestion', label: 'Gestion' },
];

export const menuItems = [
  {
    id: 'dashboard',
    group: 'pilotage',
    text: 'Tableau de bord',
    icon: 'bar-chart-line',
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
    link: '/dashboard',
  },
  {
    id: 'users',
    group: 'gestion',
    text: 'Utilisateurs',
    icon: 'people',
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
    link: '/users',
  },
  {
    id: 'surveys',
    group: 'gestion',
    text: 'Enquêtes',
    icon: 'file-earmark',
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.PROFESSIONAL],
    linksByRole: {
      [ROLES.SUPER_ADMIN]: '/surveys',
      [ROLES.ADMIN]: '/surveys',
      [ROLES.PROFESSIONAL]: '/my-surveys',
    },
  },
  {
    id: 'companies',
    group: 'gestion',
    text: 'Entreprises',
    icon: 'building',
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.PROFESSIONAL],
    link: '/companies',
  },
  {
    id: 'questions',
    group: 'gestion',
    text: 'Questions',
    icon: 'file-earmark-diff',
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
    link: '/questions',
  },
];
